module.exports = __webpack_public_path__ + "media/images/checkout/desconto-ori-03505c291cbf1216fd471cd88f2d5fc0.png";